/* eslint-disable react/no-children-prop */
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import TimeAgo from 'react-timeago';
import { Wrapper, Label, Content, Tool } from './styled';

const LastExecution = ({ lastExecution, tool, cloudAgent }) => {
  const intl = useIntl();
  const labelId = cloudAgent ? 'agents.cloudAgents.lastToolExecution' : 'agents.item.lastExecution';
  const label = intl.formatMessage({ id: labelId });
  const noExecution = intl.formatMessage({ id: 'agents.item.lastExecution.never' });

  return (
    <Wrapper>
      <Label children={ label } />
      <Content>
        { lastExecution ? <TimeAgo date={ lastExecution } /> : <div children={ noExecution } /> }
        { tool && !cloudAgent && <Tool>{` (${tool})`}</Tool> }
      </Content>
    </Wrapper>
  );
};

LastExecution.propTypes = {
  lastExecution: PropTypes.string.isRequired
};

export default LastExecution;
